import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle = () => {
  const { darkMode, setDarkMode } = useTheme();

  return (
    <button 
      className="theme-toggle" 
      onClick={() => setDarkMode(!darkMode)}
      title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      <i className={`fa ${darkMode ? 'fa-sun-o' : 'fa-moon-o'}`}></i>
    </button>
  );
};

export default ThemeToggle;